'use client'

import useMount from "react-use/lib/useMount";
import appPackage from "package.json";
import { useSearchParams, useRouter, usePathname } from "next/navigation";
import dynamic from "next/dynamic";
import type { AppProps } from "next/app";
// import { Partytown } from "@builder.io/partytown/react";
import { useDispatch } from "react-redux";
import Header from "components/Header";
import Footer from "components/Footer";
import Page from "components/Page";
import { Provider } from "../context/context";
import Datadog from 'components/Head/Datadog'
import './global.css';


const AuthModal = dynamic(() => import("components/Auth/CombiModal"), {
  ssr: false,
});


import initGA from "lib/ga/init";
import { wrapper } from "lib/store";
import { modalSet, nextModalSet } from "_slices/view";
import { setInviteCode, setResetCode } from "_slices/auth";
import AuthService from "_api/AuthService";

const CookieMessage = dynamic(() => import("components/CookieMessage"), {
  ssr: false,
});


function MyApp({ Component, pageProps = {}, children, hasToken }: AppProps) {
  const router = useSearchParams();
  const routerMeth = useRouter();
  const pathname = usePathname();
  const reduxDispatch = useDispatch();
  useMount(() => {
    initGA();

    //const searchParams = urlParamsToObject(router);

    // Check for an modal parameters and pass them to the state
    if (router.get('modal')) {
      let [type, view] = router.get('modal').split("-");
      reduxDispatch(
        modalSet({
          visible: true,
          type,
          view,
          isLoggedIn: true,
          router: routerMeth
        })
      );
    }
    if (router.get('nextModal')) {
      let [type, view] = router.get('nextModal').split("-");
      reduxDispatch(
        nextModalSet({
          visible: true,
          type,
          view,
          isLoggedIn: hasToken,
          router: routerMeth
        })
      );
    }

    if (router.get('inviteCode')) reduxDispatch(setInviteCode({ inviteCode: router.get('inviteCode'), router: routerMeth }));
    if (router.get('resetCode')) reduxDispatch(setResetCode({ resetCode: router.get('resetCode'), router: routerMeth }));
  });
  return (
    <main>
      {String(process.env.NEXT_PUBLIC_DATADOG_ACTIVE) === '1' &&
        <Datadog/>
      }
      <Provider loggedIn={hasToken}>
        <Header isApplicationWrapper={pageProps.applicationWrapper} />
        <Page transparent={pathname === '/'}>
          {children}
        </Page>

        <Footer isApplicationWrapper={pageProps.applicationWrapper} showPopular={pageProps.showPopular} />
        <CookieMessage />
        <AuthModal />
        <AuthService />
      </Provider>


    </main>
  );
}

export default wrapper.withRedux(MyApp);
